module.exports = __webpack_public_path__ + "static/media/Logo_Web.1a1569e4.png";